var _excluded = ["context"];
import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import React, { useContext } from 'react';
import ReactDOM from 'react-dom';
import { createContainer } from '@modern-js/plugin';
import { runtime, AppComponentContext } from "./plugin";
import { RuntimeReactContext } from "./runtime-context";
import { createLoaderManager } from "./loader/loaderManager";
import { jsx as _jsx } from "react/jsx-runtime";
var runnerMap = new WeakMap();
export var createApp = function createApp(_ref) {
  var plugins = _ref.plugins;
  var appRuntime = runtime.clone();
  appRuntime.usePlugin.apply(appRuntime, _toConsumableArray(plugins));
  return function (App) {
    var runner = appRuntime.init({});
    var container = createContainer({
      App: AppComponentContext.create(App)
    });

    var WrapperComponent = function WrapperComponent(props) {
      var element = /*#__PURE__*/React.createElement(App, _objectSpread({}, props), props.children);
      return runner.provide({
        element: element,
        props: _objectSpread({}, props),
        context: {}
      }, {
        container: container,
        // eslint-disable-next-line @typescript-eslint/no-shadow
        onLast: function onLast(_ref2) {
          var element = _ref2.element;
          return element;
        }
      });
    };

    Object.assign(WrapperComponent, App);
    var HOCApp = runner.hoc({
      App: WrapperComponent
    }, {
      container: container,
      // eslint-disable-next-line @typescript-eslint/no-shadow
      onLast: function onLast(_ref3) {
        var App = _ref3.App;

        var WrapComponent = function WrapComponent(_ref4) {
          var context = _ref4.context,
              props = _objectWithoutProperties(_ref4, _excluded);

          var contextValue = context;

          if (!contextValue) {
            contextValue = {
              loaderManager: createLoaderManager({}),
              runner: runner
            };
            runner.init({
              context: contextValue
            }, {
              onLast: function onLast(_ref5) {
                var _init, _ref6;

                var context1 = _ref5.context;
                App === null || App === void 0 ? void 0 : (_init = (_ref6 = App).init) === null || _init === void 0 ? void 0 : _init.call(_ref6, context1);
              }
            });
          }

          return /*#__PURE__*/_jsx(RuntimeReactContext.Provider, {
            value: contextValue,
            children: /*#__PURE__*/_jsx(App, _objectSpread({}, props))
          });
        };

        return Object.assign(WrapComponent, WrapperComponent);
      }
    });
    runnerMap.set(HOCApp, runner);
    return HOCApp;
  };
};
export var bootstrap = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(App, id) {
    var runner, context, runInit, _window, _window$_SSR_DATA, _window$_SSR_DATA$dat, loadersData, initialLoadersState;

    return _regeneratorRuntime.wrap(function _callee2$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            runner = runnerMap.get(App);
            context = {
              loaderManager: createLoaderManager({}),
              runner: runner
            };

            runInit = function runInit(_context) {
              return runner.init({
                context: _context
              }, {
                onLast: function onLast(_ref8) {
                  var _init2, _ref9;

                  var context1 = _ref8.context;
                  App === null || App === void 0 ? void 0 : (_init2 = (_ref9 = App).init) === null || _init2 === void 0 ? void 0 : _init2.call(_ref9, context1);
                }
              });
            };

            if (!(typeof window !== 'undefined')) {
              _context3.next = 9;
              break;
            }

            loadersData = ((_window = window) === null || _window === void 0 ? void 0 : (_window$_SSR_DATA = _window._SSR_DATA) === null || _window$_SSR_DATA === void 0 ? void 0 : (_window$_SSR_DATA$dat = _window$_SSR_DATA.data) === null || _window$_SSR_DATA$dat === void 0 ? void 0 : _window$_SSR_DATA$dat.loadersData) || {};
            initialLoadersState = Object.keys(loadersData).reduce(function (res, key) {
              var loaderData = loadersData[key];

              if (loaderData.loading !== false || loaderData.error || !loaderData.data) {
                return res;
              }

              res[key] = loaderData.data;
              return res;
            }, {});
            Object.assign(context, {
              loaderManager: createLoaderManager(initialLoadersState, {
                skipStatic: true
              })
            });
            runInit(context);
            return _context3.abrupt("return", runner.client({
              App: App,
              context: context,
              rootElement: typeof id !== 'string' ? id : document.getElementById(id || 'root')
            }, {
              // eslint-disable-next-line @typescript-eslint/no-shadow
              onLast: function () {
                var _onLast = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref10) {
                  var App, rootElement;
                  return _regeneratorRuntime.wrap(function _callee$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          App = _ref10.App, rootElement = _ref10.rootElement;
                          ReactDOM.render( /*#__PURE__*/React.createElement(App, {
                            context: context
                          }), rootElement);

                        case 2:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee);
                }));

                function onLast(_x3) {
                  return _onLast.apply(this, arguments);
                }

                return onLast;
              }()
            }));

          case 9:
            Object.assign(context, {
              ssrContext: id,
              loaderManager: createLoaderManager({}, {
                skipNonStatic: id.staticGenerate,
                // if not static generate, only non-static loader can exec on prod env
                skipStatic: process.env.NODE_ENV === 'production' && !id.staticGenerate
              })
            });
            runInit(context);
            return _context3.abrupt("return", runner.server({
              App: App,
              context: context
            }));

          case 12:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee2);
  }));

  return function bootstrap(_x, _x2) {
    return _ref7.apply(this, arguments);
  };
}();
export var useRuntimeContext = function useRuntimeContext() {
  var context = useContext(RuntimeReactContext);
  return context.runner.pickContext({
    context: context,
    pickedContext: {}
  }, {
    onLast: function onLast(_ref11) {
      var pickedContext = _ref11.pickedContext;
      return pickedContext;
    }
  });
};